// ─────────────────────────────
// CHAPTER ACTION TYPES
// ─────────────────────────────

// FETCH CHAPTERS
export const FETCH_CHAPTERS_REQUEST = 'FETCH_CHAPTERS_REQUEST';
export const FETCH_CHAPTERS_SUCCESS = 'FETCH_CHAPTERS_SUCCESS';
export const FETCH_CHAPTERS_FAILURE = 'FETCH_CHAPTERS_FAILURE';

// ADD CHAPTER
export const ADD_CHAPTER_REQUEST = 'ADD_CHAPTER_REQUEST';
export const ADD_CHAPTER_SUCCESS = 'ADD_CHAPTER_SUCCESS';
export const ADD_CHAPTER_FAILURE = 'ADD_CHAPTER_FAILURE';

// UPDATE CHAPTER
export const UPDATE_CHAPTER_REQUEST = 'UPDATE_CHAPTER_REQUEST';
export const UPDATE_CHAPTER_SUCCESS = 'UPDATE_CHAPTER_SUCCESS';
export const UPDATE_CHAPTER_FAILURE = 'UPDATE_CHAPTER_FAILURE';

// DELETE CHAPTER
export const DELETE_CHAPTER_REQUEST = 'DELETE_CHAPTER_REQUEST';
export const DELETE_CHAPTER_SUCCESS = 'DELETE_CHAPTER_SUCCESS';
export const DELETE_CHAPTER_FAILURE = 'DELETE_CHAPTER_FAILURE';
